/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TechnicalAccountList } from '../../models/technical-account-list';

export interface SearchTechnicalAccount$Params {

/**
 * The search text to filter API
 */
  search?: string;
}

export function searchTechnicalAccount(http: HttpClient, rootUrl: string, params?: SearchTechnicalAccount$Params, context?: HttpContext): Observable<StrictHttpResponse<TechnicalAccountList>> {
  const rb = new RequestBuilder(rootUrl, searchTechnicalAccount.PATH, 'post');
  if (params) {
    rb.query('search', params.search, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TechnicalAccountList>;
    })
  );
}

searchTechnicalAccount.PATH = '/technical-accounts/search';
